import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyhole2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconKeyhole2"><Path d="M12 2C15.866 2 19 5.13401 19 9C19 11.3909 17.7998 13.4987 15.9736 14.7607L18.3877 22H5.6123L8.02539 14.7607C6.19957 13.4987 5 11.3906 5 9C5 5.13401 8.13401 2 12 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyhole2;
